<template>
  <div v-if="videoUrl" class="video-responsive">
    <div ref="artplayerContainer" class="artplayer-app"></div>
  </div>
</template>

<script>
import Artplayer from "artplayer";

export default {
  name: "VideoPlayer",
  props: {
    videoUrl: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      artPlayer: null
    };
  },
  methods: {
    initializeVideoPlayer() {
      const container = this.$refs.artplayerContainer;
      if (!container) {
        console.error("VideoPlayer - Container not found");
        return;
      }
      
      if (!this.videoUrl) {
        console.error("VideoPlayer - No video URL provided");
        return;
      }

      try {
        this.artPlayer = new Artplayer({
          container: container,
          url: this.videoUrl,
          autoplay: false,
          setting: true,
          playbackRate: true,
          aspectRatio: true,
          fullscreen: true,
          fullscreenWeb: true,
          miniProgressBar: true,
          icons: {
            state: '<i class="uil-play"></i>',
          },
          lang: "tr",
        });
        
      } catch (error) {
        console.error("VideoPlayer - Error creating Artplayer:", error);
      }
    },
    destroyVideoPlayer() {
      if (this.artPlayer && this.artPlayer.destroy) {
        this.artPlayer.destroy(false);
        this.artPlayer = null;
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initializeVideoPlayer();
    });
  },
  beforeDestroy() {
    this.destroyVideoPlayer();
  },
  watch: {
    videoUrl(newUrl, oldUrl) {
      if (newUrl !== oldUrl) {
        this.destroyVideoPlayer();
        this.$nextTick(() => {
          this.initializeVideoPlayer();
        });
      }
    }
  }
};
</script>

<style >
.video-responsive {
  text-align: center;
  margin-bottom: 1rem;
}

.artplayer-app {
  width: 100%;
  height: calc(100vh - 200px);
  min-height: 600px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

</style> 